import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '89vh',
    [theme.breakpoints.down('sm')]: {
      backgroundColor: theme.palette.white,
      overflowY: 'scroll',
      overflowX: 'hidden',
      justifyContent: 'flex-start',
    },
  },
  containerBox: {
    overflow: 'auto',
    maxHeight: '100%',
    borderRadius: '0 0 8px 8px',
  },

  titleBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    paddingBottom: theme.spacing(5),
    paddingTop: theme.spacing(5),
  },

  formBox: {
    display: 'flex',
    flexDirection: 'column',
  },

  input: {
    marginTop: theme.spacing(3),
  },

  container: {
    boxShadow: 'inset 0 0 0em white, 0 0 2em #ccc;',
    width: '50%',
    maxWidth: '532px',
    height: '600px',
    borderRadius: '0.8rem',
    backgroundColor: theme.palette.white,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      height: 'auto',
      marginTop: '15px',
    },
  },

  form: {
    backgroundColor: theme.palette.white,
    padding: '0 40px 24px 40px',
  },

  fieldGroup: {
    paddingBottom: theme.spacing(3),
  },

  footer: {
    textAlign: 'center',
  },

  title: {
    textAlign: 'center',
    color: '#707070',
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },

  subtitle: {
    textAlign: 'center',
    color: '#707070',
    fontSize: '18px',
  },

  passwordField: {
    marginTop: theme.spacing(-3),
  },

  sendButton: {
    margin: theme.spacing(2, 0),
  },

  backDiv: {
    width: '40%',
    margin: '20px 0px 0px 30px',
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  backButton: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
}));
